import { axiosInstance } from 'services/axiosInstance'

const getHeaderFooterData = (): Promise<any> =>
  axiosInstance.get('/home-loan-be/api/v1/ldp/home-page/header-footer')

export { getHeaderFooterData }
